import {XHTTP} from '@/shared/xhttp';
import {DateHelper} from "@/shared/utils";

export type ReglementType = 'Chèque'|'Virement';
export const ReglementType = {
	Cheque   : 'Chèque' as ReglementType,
	Virement: 'Virement' as ReglementType,
};


export class SuiviReglement {

	private _id: number;
	private _date: Date = new Date();
	private _montantUnitaire: number = 0;
	private _quantite: number = 1;
	private _montant: number = 0;
	private _reference: string;
	private _type: ReglementType = ReglementType.Cheque;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get date(): Date {
		return this._date;
	}

	public get montantUnitaire(): number {
		return this._montantUnitaire;
	}

	public get quantite(): number {
		return this._quantite;
	}

	public get montant(): number {
		return this._montant;
	}

	public get reference(): string {
		return this._reference;
	}

	public get type(): ReglementType {
		return this._type ? <any>this._type.toString() : null;
	}

	/////////////
	// Setters //
	/////////////

	public set date(value: Date) {
		this._date = value;
	}

	public set montantUnitaire(value: number) {
		this._montantUnitaire = value;
		this._montant = Math.round((value * this._quantite + Number.EPSILON) * 100) / 100;
	}

	public set quantite(value: number) {
		this._quantite = value;
		this._montant = Math.round((value * this._montantUnitaire + Number.EPSILON) * 100)/ 100;
	}

	public set montant(value: number) {
		this._montant = value;
		this._montantUnitaire = Math.round((value / this._quantite + Number.EPSILON) * 100)/ 100;
	}

	public set reference(value: string) {
		this._reference = value;
	}

	public set type(value: ReglementType) {
		this._type = value;
	}

	///////////////
	// Serialize //
	///////////////

	public toJSON(): any {
		return {
			id            : this._id,
			date 		: this._date ? DateHelper.toLocalizedString(this._date) : null,
			montantUnitaire       : this._montantUnitaire,
			quantite       : this._quantite,
			montant       : this._montant,
			reference : this._reference,
			type : this._type ? this._type.toString() : null,
		};
	}

	public fromJSON(data: any): this {
		this._id           = data.id
		this._date         = data.date ? DateHelper.fromLocalizedString(data.date) : null;
		this._montantUnitaire        = data.montantUnitaire;
		this._quantite        = data.quantite;
		this._montant        = data.montant;
		this._reference  = data.reference;
		this._type	   = data.type;
		return this;
	}
}
